import { render, staticRenderFns } from "./createQrcode.vue?vue&type=template&id=5c523e0d&"
import script from "./createQrcode.vue?vue&type=script&lang=js&"
export * from "./createQrcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports